import celltherapy360Logo from 'assets/CT360-LOGO-RBG_CT360.png';
import bmsLogo from 'assets/bms_logo_rgb_pos_150.png';
import pluvictoLogo from 'assets/pluvicto_logo.png';
import lutatheraLogo from 'assets/lutathera-logo.png';
import novartisLogo from 'assets/Novartis_Logo_RGB.png';
import cizplamLogo from 'assets/Cizplam_logo.png';
import ventixalLogo from 'assets/ventixal_logo.png';
import uroliftLogo from 'assets/UROLIFT_2c_GoldO_BKTAG.png';
import teleflexLogo from 'assets/Teleflex_Logo_BK.png';
import teleflexLogoNavy from 'assets/Teleflex_Global_Corporate_Brand_Logo_CMYK_Navy.png';
import saphneloLogoRtm from 'assets/saphnelo-new.png';
import imjudoLogo from 'assets/imjudo-a360.png';
import aquablationLogo from 'assets/Aquablation_Logo_RGB_Lockup_150.png';
import proceptBioroboticsLogo from 'assets/PROCEPT_Logo_Solid_RGB_150.png';
import imfinziImjudoAccess360 from 'assets/imfinzi-imjudo-access360.png';
import fasenraLogo from 'assets/FASENRA_R_logo_exUS_RGB_Icon_Left.jpg';
import azLogoWhite from 'assets/astraZeneca.png';
import azLogo from 'assets/AZ-logo.png';
import enrouteLogo from 'assets/ENROUTE-Wordmark-2024-Digital_Stacked-Color.png';
import bostonScientificLogo from 'assets/BSC_541blue.svg';
import leqembiLogo from 'assets/logo-leqembi.png';
import eisaiLogo from 'assets/eisai.png';
import spravatoLogo from 'assets/Spravato_logo_r_c3_color_rgb.png';
import jjLogo from 'assets/JJ_Logo_SingleLine_Red_RGB.png';
import nurtecLogo from 'assets/nurtec-logo.jpg';
import pfizerLogo from 'assets/pfizer-logo.png';
import pfizerWhiteLogo from 'assets/pfizer-white-logo.svg';
import pfizerDermatologyLogo from 'assets/Pfizer-Dermatology-Patient-Access-logo.png';
import zavzpretLogo from 'assets/Zavzpret_R_RBG_Logo.jpg';
import barrigelLogo from 'assets/Barrigel_Primary_Trademark Logo_RGB_4C.png';
import amtagviLogo from 'assets/Amtagvi_Iovance_cares_logo.png';
import iovanceLogo from 'assets/iovance-biotherapeutics-logo.png';
import inspireLogo from 'assets/Inspire_Primary_Logo_RGB-4-blue.png';
import inspireLogoWhite from 'assets/Inspire_Primary_Logo_RGB-4-white.png';
import kisunlaLogo from 'assets/pngwithsrgbspace.png';
import lillyLogo from 'assets/Lilly_Company_Logo.png';

const logoAssets = {
  // Abecma.
  'celltherapy360-logo.png': celltherapy360Logo,
  'bms-logo.png': bmsLogo,
  // Pluvicto & lutathera.
  'pluvicto_logo.png': pluvictoLogo,
  'lutathera-logo.png': lutatheraLogo,
  'novartis_logo.png': novartisLogo,
  // Cizplam Sales Demo site.
  'cizplam-logo.png' : cizplamLogo,
  // Ventixal Sales Demo site.
  'ventixal-logo.png' : ventixalLogo,
  // Urolift.
  'urolift-logo.png': uroliftLogo,
  // Astrazeneca Saphnelo NOC.
  'saphnelo-logo-rtm.png': saphneloLogoRtm,
  // Astrazeneca Imjudo NOC.
  'imjudo-logo.png': imjudoLogo,
  // Multiple AZ sites - Note: ALL AZ sites share this image.
  'az-logo.png': azLogo,
  'az-logo-white.png': azLogoWhite,
  // Fasenra.
  'fasenra-logo.png': fasenraLogo,
  // Aquablation
  'aquablation-logo.png': aquablationLogo,
  'procept-biorobotics-logo.png': proceptBioroboticsLogo,
  //Imfinzi + Imjudo
  'imfinzi-imjudo-access360.png': imfinziImjudoAccess360,
  //enroute - s3://policyreporter-customer-documentation/bostonsci-fonts/ must be deleted when the enroute/tcar website is removed
  'enroute-logo.png': enrouteLogo,
  'boston-sci-logo.svg': bostonScientificLogo,
  //leqembi
  'leqembi-logo.png': leqembiLogo,
  'eisai-logo.png': eisaiLogo,
  //spravato
  'spravato-logo.png': spravatoLogo,
  'jj-logo.png': jjLogo,
  //pfizer
  'pfizer-logo.png': pfizerLogo,
  'pfizer-white-logo.png': pfizerWhiteLogo,
  'pfizer-dermatology-logo.png': pfizerDermatologyLogo,
  //zavzpret
  'zavzpret-logo.png': zavzpretLogo,
  //nurtec
  'nurtec-logo.jpg': nurtecLogo,
  //Barrigel
  'teleflex-logo.png': teleflexLogo,
  'teleflex-logo-navy.png': teleflexLogoNavy,
  'barrigel-logo.png': barrigelLogo,
  //Iovance
  'amtagvi-logo.png': amtagviLogo,
  'iovance-logo.jpeg': iovanceLogo,
  //Inspire Therapy
  'inspire-logo.png': inspireLogo,
  'inspire-logo-white.png': inspireLogoWhite,
  //Kisunla
  'kisunla-logo.png': kisunlaLogo,
  'lilly-logo.png': lillyLogo,
};

export default logoAssets;
